import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppBrand from '../components/AppBrand';

function BillingTermsPage({ theme = 'dark' }) {
  const navigate = useNavigate();
  const darkMode = theme === 'dark';

  return (
    <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
      <div className="legal-page-container">
        <AppBrand theme={theme} />
        <div className="legal-page-topbar">
          <button
            type="button"
            className="back-link-btn"
            onClick={() => navigate('/')}
          >
            ← Back to App
          </button>
        </div>

        <div className="legal-page-card">
          <div className="legal-page-badge">Billing</div>
          <h1 className="legal-page-title">Subscription & Billing Terms</h1>

          <section className="legal-section">
            <h2>1. Subscription Access</h2>
            <p>
              Certain features of StockVested are available only through a paid
              subscription. Subscription access may include recurring billing and
              automatic renewal unless canceled.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Pricing</h2>
            <p>
              Subscription pricing, billing intervals, and included features will be
              displayed at checkout or on the pricing page. Prices may change in the
              future as permitted by law.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Automatic Renewal</h2>
            <p>
              If you purchase a recurring subscription, you authorize us and our
              payment processor to charge your payment method automatically for each
              renewal period until you cancel.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Trials</h2>
            <p>
              If a trial is offered, your access may automatically convert to a paid
              plan unless you cancel before the trial ends, subject to the terms shown
              at signup or checkout.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Cancellation</h2>
            <p>
              You may cancel your subscription through the billing portal or other
              method provided inside the product. Unless otherwise stated, cancellation
              prevents future renewals but does not necessarily create a refund for
              charges already processed.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Refunds</h2>
            <p>
              Except where required by law, payments are non-refundable once charged.
              Any exception, courtesy refund, or promotional adjustment is made at our
              discretion unless otherwise stated.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Failed Payments</h2>
            <p>
              If a payment fails, access to paid features may be limited, suspended,
              or canceled until billing is successfully resolved.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Third-Party Processor</h2>
            <p>
              Subscription payments are processed by third-party providers such as
              Stripe. Your payment relationship may also be governed by that
              provider’s terms and policies.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default BillingTermsPage;